var defaultStyles = {
  "tag": "Base-Tag--Tag",
  "checkable": "Base-Tag--Checkable",
  "checked": "Base-Tag--Checked",
  "bordered": "Base-Tag--Bordered",
  "xs": "Base-Tag--Xs",
  "sm": "Base-Tag--Sm",
  "md": "Base-Tag--Md",
  "lg": "Base-Tag--Lg",
  "hide": "Base-Tag--Hide",
  "loading": "Base-Tag--Loading",
  "icon": "Base-Tag--Icon",
  "custom_color": "Base-Tag--CustomColor",
  "close_btn": "Base-Tag--CloseBtn",
  "loading_icon": "Base-Tag--LoadingIcon",
  "anim-rotate": "Base-Tag__anim--Rotate",
  "default": "Base-Tag--Default",
  "critical": "Base-Tag--Critical",
  "warning": "Base-Tag--Warning",
  "pending": "Base-Tag--Pending",
  "success": "Base-Tag--Success",
  "info": "Base-Tag--Info"
};

export { defaultStyles as default };
